import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'maximizer-outlook-iq-boost-loader',
  imports: [TranslatePipe],
  template: `
    <div
      class="flex gap-3 flex-col items-center justify-center w-full h-full"
      role="status"
      [aria-label]="'outlook.iqBoost.processing' | translate"
      aria-live="polite"
    >
      <svg
        class="block w-20 h-20"
        viewBox="0 0 50 48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- ROTATING GROUP | Circle Star -->
        <g class="spinner-outer">
          <path
            d="M2.95776 21.2237C3.08346 21.2237 3.19392 21.3018 3.24534 21.4161L4.03002 23.1895L5.73077 24.0067C5.84124 24.06 5.91552 24.1762 5.91552 24.3076C5.91552 24.4391 5.84124 24.5533 5.73077 24.6086L4.03002 25.4258L3.24534 27.1992C3.19392 27.3154 3.08346 27.3916 2.95776 27.3916C2.83206 27.3916 2.72159 27.3134 2.67017 27.1992L1.8855 25.4258L0.184741 24.6086C0.0742772 24.5552 0 24.4391 0 24.3076C0 24.1762 0.0742772 24.0619 0.184741 24.0067L1.8855 23.1895L2.67017 21.4161C2.72159 21.2999 2.83206 21.2237 2.95776 21.2237Z"
            fill="#3B7918"
          />
          <path
            d="M26.0027 0C25.4771 0 25.0505 0.426684 25.0505 0.952419C25.0505 1.47815 25.4771 1.90484 26.0027 1.90484C38.1842 1.90484 48.0955 11.8176 48.0955 24.001C48.0955 36.1843 38.1842 46.0971 26.0027 46.0971C14.9926 46.0971 5.83742 37.9996 4.17856 27.4449L4.11571 27.5897C3.91002 28.0487 3.45674 28.3459 2.95775 28.3459C2.75015 28.3459 2.55208 28.2926 2.37305 28.1973C4.3633 39.4378 14.2022 48 26.0027 48C39.2355 48 50 37.2339 50 23.999C50 10.7642 39.2355 0 26.0027 0Z"
            fill="#3B7918"
          />
        </g>
        <!-- STATIC CENTER | IQ* -->
        <path
          d="M25.9494 17.0146L25.9539 17.1469C26.0002 17.8003 26.3876 18.3555 26.9311 18.6202L26.9365 18.6231L27.4471 18.8688C27.353 18.8585 27.2562 18.8538 27.1567 18.8538C26.747 18.8538 26.3826 18.9411 26.0645 19.1154C25.7463 19.2842 25.4792 19.5376 25.2635 19.8751C25.0478 20.2127 24.8833 20.6292 24.77 21.1243C24.6567 21.6195 24.6001 22.1935 24.6001 22.8462V23.4455C24.6001 24.0926 24.6567 24.6666 24.77 25.1673C24.8833 25.6625 25.0478 26.0818 25.2635 26.425C25.4846 26.7625 25.7544 27.0187 26.0726 27.1931C26.3961 27.3674 26.7632 27.4548 27.1729 27.4548C27.5826 27.4547 27.9443 27.3675 28.257 27.1931C28.5751 27.0187 28.8424 26.7625 29.058 26.425C29.2791 26.0818 29.4464 25.6625 29.5596 25.1673C29.6729 24.6666 29.7295 24.0926 29.7295 23.4455V22.8462C29.7295 22.3071 29.6855 21.8223 29.6046 21.3906C29.8137 21.4869 30.0448 21.5407 30.2878 21.5407C30.9683 21.5407 31.5561 21.1215 31.8268 20.5166L31.8295 20.5109L31.851 20.4612C32.0697 21.1707 32.1809 21.971 32.1809 22.863V23.4455C32.1809 24.3795 32.0596 25.218 31.8169 25.9608C31.5796 26.7034 31.2369 27.3367 30.7894 27.8599C30.5885 28.0923 30.3693 28.2981 30.1359 28.4817L32.1 30.1052L30.5709 31.4894L28.0683 29.3895C27.7814 29.4375 27.4832 29.4636 27.1729 29.4636C26.4341 29.4636 25.7569 29.3256 25.1421 29.05C24.5274 28.7744 23.996 28.3775 23.5483 27.8599C23.1007 27.3367 22.7527 26.7035 22.5046 25.9608C22.2619 25.218 22.1396 24.3795 22.1396 23.4455V22.863C22.1396 21.9233 22.2619 21.0849 22.5046 20.3477C22.7527 19.605 23.098 18.9719 23.5402 18.4486C23.9824 17.9254 24.5112 17.5257 25.126 17.25C25.3894 17.132 25.6642 17.0399 25.9503 16.9724L25.9494 17.0146Z"
          fill="#3B7918"
        />
        <path
          d="M19.9165 17.0043V29.2939H17.4974V17.0043H19.9165Z"
          fill="#3B7918"
        />
        <path
          d="M30.2878 13.9282C30.4133 13.9282 30.5241 14.0054 30.5758 14.121L31.36 15.895L33.0604 16.7131C33.1713 16.7671 33.2453 16.8826 33.2453 17.0137C33.2453 17.1448 33.1713 17.2602 33.0604 17.3142L31.36 18.1323L30.5758 19.9063C30.5241 20.022 30.4133 20.0991 30.2878 20.0991C30.162 20.0991 30.0514 20.022 29.9996 19.9063L29.2155 18.1323L27.5151 17.3142C27.4041 17.2602 27.3302 17.1448 27.3302 17.0137C27.3302 16.8826 27.4041 16.7671 27.5151 16.7131L29.2155 15.895L29.9996 14.121C30.0514 14.0054 30.162 13.9282 30.2878 13.9282Z"
          fill="#3B7918"
        />
      </svg>

      <h6 class="text-bush-green-100">
        {{ 'outlook.iqBoost.processing' | translate }}
      </h6>
    </div>
  `,
  styles: [
    `
      .spinner-outer {
        transform-origin: 26px 24px;
        animation: iqBoostSpin 1s linear infinite;
      }

      @keyframes iqBoostSpin {
        to {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class OutlookIqBoostLoaderComponent {}
